import { Accordion } from '@cimpress/react-components';
import React, { useState } from 'react';
import MapPoints from '../../documents/transforms/mapPoints';
import ColorProfile from './colorProfile';
import PrintWhiteHint from '../printWhiteHint';
import { DocumentEffect } from 'src/config/effects';
import EffectsView from './effects';

interface Props {
    id: string;
    effect?: DocumentEffect;
    changeProfileColor: (data: { id: string; colorProfile: string }) => void;
    colorProfile?: string;
    printWhite: boolean | null;
    setEffect: (data: { id: string; effectType: string }) => void;
    updateEffectProperty: (data: { id: string; property: string; value: any }) => void;
}

const AdvancedView: React.FC<Props> = ({
    id,
    effect,
    changeProfileColor,
    colorProfile,
    printWhite,
    setEffect,
    updateEffectProperty,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = (_: any, isOpen: boolean) => {
        setIsOpen(isOpen);
    };

    return (
        <div className='advanced__tools'>
            <Accordion
                variant='minimal'
                title={isOpen ? 'Hide Advanced' : 'Show Advanced'}
                className='advanced__tools__content'
                onHeaderClick={handleClick}>
                <h3>Color Properties</h3>
                <ColorProfile
                    activeProfile={colorProfile}
                    onSelect={(e) => changeProfileColor({ id, colorProfile: e.value })}
                />
                <PrintWhiteHint printWhite={printWhite} />
                <h3>Position</h3>
                <MapPoints id={id} />
                <h3>Effects</h3>
                <EffectsView
                    id={id}
                    effect={effect}
                    setEffect={setEffect}
                    updateEffectProperty={updateEffectProperty}
                />
            </Accordion>
        </div>
    );
};

export default React.memo(AdvancedView);
